export const fetchEmployerMetrics = (BeURL, showAlert, setCounts) => {
    fetch(`${BeURL}/employer/metrics`, { credentials: 'include' })
    .then(res => res.json())
    .then(data => {
        if (data.success) {
            setCounts(data.metrics);
        }
        else {
            const metrics = {
                searchCandidates: data.totalCandidates || 0,
                proSearch: data.totalCandidates || 0,
                manageJobs: 0,
                applicants: 0
            }
            setCounts(metrics);
            if (!data.totalCandidates) showAlert(data.message)
        }
    })
    .catch(err => {
        console.log('Error fetching metrics:', err);
        showAlert('Unable to load dashboard data.');
    });
}